"use strict";
/*
 * Copyright 2017-2017 Amazon.com, Inc. or its affiliates. All Rights Reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License"). You may not use this file except in compliance with
 * the License. A copy of the License is located at
 *
 *     http://aws.amazon.com/apache2.0/
 *
 * or in the "license" file accompanying this file. This file is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR
 * CONDITIONS OF ANY KIND, either express or implied. See the License for the specific language governing permissions
 * and limitations under the License.
 */
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var core_1 = require("@aws-amplify/core");
var auth_1 = require("@aws-amplify/auth");
var core_2 = require("@material-ui/core");
var AuthPiece_1 = require("./AuthPiece");
var Amplify_UI_Components_React_1 = require("../Amplify-UI/Amplify-UI-Components-React");
var data_test_attributes_1 = require("../Amplify-UI/data-test-attributes");
var country_dial_codes_js_1 = require("./common/country-dial-codes.js");
var default_sign_up_fields_1 = require("./common/default-sign-up-fields");
var types_1 = require("./common/types");
var PhoneField_1 = require("./PhoneField");
var logger = new core_1.ConsoleLogger('SignUp');
var PNF = require('google-libphonenumber').PhoneNumberFormat;
var phoneUtil = require('google-libphonenumber').PhoneNumberUtil.getInstance();
var SignUp = /** @class */ (function (_super) {
    __extends(SignUp, _super);
    function SignUp(props) {
        var _this = _super.call(this, props) || this;
        _this.handleWindowSizeChange = function (e) {
            _this.setState({ mobile: window.innerWidth <= 1280 });
        };
        _this._validAuthStates = ['signUp'];
        _this.signUp = _this.signUp.bind(_this);
        _this.sortFields = _this.sortFields.bind(_this);
        _this.getDefaultDialCode = _this.getDefaultDialCode.bind(_this);
        _this.checkCustomSignUpFields = _this.checkCustomSignUpFields.bind(_this);
        _this.needPrefix = _this.needPrefix.bind(_this);
        _this.header = (_this.props &&
            _this.props.signUpConfig &&
            _this.props.signUpConfig.header) ? _this.props.signUpConfig.header : 'Sign Up';
        var _a = (_this.props || {}).usernameAttributes, usernameAttributes = _a === void 0 ? types_1.UsernameAttributes.USERNAME : _a;
        if (usernameAttributes === types_1.UsernameAttributes.EMAIL) {
            _this.defaultSignUpFields = default_sign_up_fields_1.signUpWithEmailFields;
        }
        else if (usernameAttributes === types_1.UsernameAttributes.PHONE_NUMBER) {
            _this.defaultSignUpFields = default_sign_up_fields_1.signUpWithPhoneNumberFields;
        }
        else {
            _this.defaultSignUpFields = default_sign_up_fields_1.default;
        }
        _this.state = {
            mobile: false,
        };
        return _this;
    }
    SignUp.prototype.componentDidMount = function () {
        window.addEventListener('resize', this.handleWindowSizeChange);
    };
    SignUp.prototype.componentWillUnmount = function () {
        window.removeEventListener('resize', this.handleWindowSizeChange);
    };
    SignUp.prototype.validate = function () {
        var _this = this;
        var invalids = [];
        this.signUpFields.map(function (el) {
            if (el.key !== 'phone_number') {
                if (el.required && !_this.inputs[el.key]) {
                    el.invalid = true;
                    invalids.push(el.label);
                }
                else {
                    el.invalid = false;
                }
            }
            else {
                if (el.required && (!_this.phone_number || _this.phone_number.length < 6 || !phoneUtil.isValidNumber(phoneUtil.parse(_this.phone_number, null)))) {
                    el.invalid = true;
                    invalids.push(el.label + "Invalid Mobile Number");
                }
                else {
                    el.invalid = false;
                }
            }
        });
        return invalids;
    };
    SignUp.prototype.sortFields = function () {
        var _this = this;
        if (this.props.signUpConfig && this.props.signUpConfig.hiddenDefaults && this.props.signUpConfig.hiddenDefaults.length > 0) {
            this.defaultSignUpFields = this.defaultSignUpFields.filter(function (d) {
                return !_this.props.signUpConfig.hiddenDefaults.includes(d.key);
            });
        }
        if (this.checkCustomSignUpFields()) {
            if (!this.props.signUpConfig || !this.props.signUpConfig.hideAllDefaults) {
                // see if fields passed to component should override defaults
                this.defaultSignUpFields.forEach(function (f, i) {
                    var matchKey = _this.signUpFields.findIndex(function (d) {
                        return d.key === f.key;
                    });
                    if (matchKey === -1) {
                        _this.signUpFields.push(f);
                    }
                });
            }
            /*
              sort fields based on following rules:
              1. Fields with displayOrder are sorted before those without displayOrder
              2. Fields with conflicting displayOrder are sorted alphabetically by key
              3. Fields without displayOrder are sorted alphabetically by key
            */
            this.signUpFields.sort(function (a, b) {
                if (a.displayOrder && b.displayOrder) {
                    if (a.displayOrder < b.displayOrder) {
                        return -1;
                    }
                    else if (a.displayOrder > b.displayOrder) {
                        return 1;
                    }
                    else {
                        if (a.key < b.key) {
                            return -1;
                        }
                        else {
                            return 1;
                        }
                    }
                }
                else if (!a.displayOrder && b.displayOrder) {
                    return 1;
                }
                else if (a.displayOrder && !b.displayOrder) {
                    return -1;
                }
                else if (!a.displayOrder && !b.displayOrder) {
                    if (a.key < b.key) {
                        return -1;
                    }
                    else {
                        return 1;
                    }
                }
            });
        }
        else {
            this.signUpFields = this.defaultSignUpFields;
        }
    };
    SignUp.prototype.needPrefix = function (key) {
        if (key === "email" || key === "username") {
            return null;
        }
        var field = this.signUpFields.find(function (e) { return e.key === key; });
        if (key.indexOf('custom:') !== 0) {
            return field.custom;
        }
        else if (key.indexOf('custom:') === 0 && field.custom === false) {
            logger.warn('Custom prefix prepended to key but custom field flag is set to false; retaining manually entered prefix');
        }
        return null;
    };
    SignUp.prototype.getDefaultDialCode = function () {
        return this.props.signUpConfig &&
            this.props.signUpConfig.defaultCountryCode &&
            country_dial_codes_js_1.default.indexOf("+" + this.props.signUpConfig.defaultCountryCode) !== '-1' ?
            "+" + this.props.signUpConfig.defaultCountryCode :
            "+353";
    };
    SignUp.prototype.checkCustomSignUpFields = function () {
        return this.props.signUpConfig &&
            this.props.signUpConfig.signUpFields &&
            this.props.signUpConfig.signUpFields.length > 0;
    };
    SignUp.prototype.signUp = function () {
        var _this = this;
        if (!this.inputs.dial_code) {
            this.inputs.dial_code = this.getDefaultDialCode();
        }
        var validation = this.validate();
        if (validation && validation.length > 0) {
            return this.error("The following fields need to be filled out: " + validation.join(', '));
        }
        if (!auth_1.default || typeof auth_1.default.signUp !== 'function') {
            throw new Error('No Auth module found, please ensure @aws-amplify/auth is imported');
        }
        if (this.inputs.password !== this.inputs.confirm_password) {
            return this.error("Passwords do not match");
        }
        var signup_info = {
            username: this.inputs.username,
            password: this.inputs.password,
            attributes: {}
        };
        if (this.props.autoSignIn) {
            var _a = (this.props || {}).usernameAttributes, usernameAttributes = _a === void 0 ? types_1.UsernameAttributes.USERNAME : _a;
            if (usernameAttributes === types_1.UsernameAttributes.PHONE_NUMBER) {
                window.localStorage.setItem('aws-amplify-react-extended-username', this.phone_number);
            }
            else {
                window.localStorage.setItem('aws-amplify-react-extended-username', this.inputs.username);
            }
            window.localStorage.setItem('aws-amplify-react-extended-pw', this.inputs.password);
        }
        var inputKeys = Object.keys(this.inputs);
        var inputVals = Object.values(this.inputs);
        if (this.inputs.password !== this.inputs.confirm_password) {
            return this.error("Passwords do not match");
        }
        inputKeys.forEach(function (key, index) {
            if (!['username', 'password', 'confirm_password', 'checkedValue', 'dial_code'].includes(key)) {
                if (key !== 'phone_line_number' && key !== 'dial_code' && key !== 'error') {
                    var newKey = "" + (_this.needPrefix(key) ? 'custom:' : '') + key;
                    signup_info.attributes[newKey] = inputVals[index].toString();
                }
            }
        });
        if (this.phone_number)
            signup_info.attributes['phone_number'] = this.phone_number;
        var labelCheck = false;
        this.signUpFields.forEach(function (field) {
            if (field.label === _this.getUsernameLabel()) {
                logger.debug("Changing the username to the value of " + field.label);
                signup_info.username = signup_info.attributes[field.key] || signup_info.username;
                labelCheck = true;
            }
        });
        if (!labelCheck && !signup_info.username) {
            // if the customer customized the username field in the sign up form
            // He needs to either set the key of that field to 'username'
            // Or make the label of the field the same as the 'usernameAttributes'
            throw new Error("Couldn't find the label: " + this.getUsernameLabel() + ", in sign up fields according to usernameAttributes!");
        }
        console.log(signup_info);
        auth_1.default.signUp(signup_info).then(function (data) {
            _this.changeState('confirmSignUp', data.user.username);
        })
            .catch(function (err) { return _this.error(err); });
    };
    SignUp.prototype.checkConditions = function (conditions) {
        if (!conditions) {
            return true;
        }
        for (var key in conditions) {
            if (conditions.hasOwnProperty(key)) {
                var element = conditions[key];
                if (this.inputs[key] !== element) {
                    return false;
                }
            }
        }
        return true;
    };
    SignUp.prototype.showComponent = function (theme) {
        var _this = this;
        var _a = this.props, hide = _a.hide, uiFramework = _a.uiFramework, signUpConfig = _a.signUpConfig;
        if (hide && hide.includes(SignUp)) {
            return null;
        }
        if (this.checkCustomSignUpFields()) {
            this.signUpFields = this.props.signUpConfig.signUpFields;
        }
        this.sortFields();
        var displayHeader = true;
        if (signUpConfig && signUpConfig.displayHeader === false) {
            displayHeader = false;
        }
        console.log(this.inputs);
        return (React.createElement(Amplify_UI_Components_React_1.FormSection, { theme: theme, uiFramework: uiFramework, "data-test": data_test_attributes_1.auth.signUp.section },
            React.createElement(Amplify_UI_Components_React_1.SectionHeader, { theme: theme, uiFramework: uiFramework, "data-test": data_test_attributes_1.auth.signUp.headerSection }, displayHeader && core_1.I18n.get(this.header)),
            React.createElement(Amplify_UI_Components_React_1.SectionBody, { theme: theme, uiFramework: uiFramework, "data-test": data_test_attributes_1.auth.signUp.bodySection }, this.signUpFields.map(function (field) {
                return (React.createElement(React.Fragment, null,
                    field.key === 'username' && (React.createElement(React.Fragment, null, _this.renderUsernameField(theme, uiFramework, field))),
                    _this.checkConditions(field.conditions) &&
                        field.key === 'phone_number' &&
                        React.createElement(PhoneField_1.PhoneField, { theme: theme, uiFramework: uiFramework, callCodes: field.callCodes, required: field.required, defaultDialCode: _this.getDefaultDialCode(), label: field.label, placeholder: field.placeholder, onChangeText: _this.onPhoneNumberChanged, key: "phone_number" }),
                    _this.checkConditions(field.conditions) &&
                        field.key === 'password' && (React.createElement(React.Fragment, null,
                        React.createElement("div", { style: {
                                display: 'flex',
                                flex: 1,
                                flexDirection: _this.state.mobile ? 'column' : 'row',
                                justifyContent: 'space-between'
                            } },
                            React.createElement(React.Fragment, null,
                                React.createElement(Amplify_UI_Components_React_1.FormField, { theme: theme, uiFramework: uiFramework, key: "password" },
                                    React.createElement(Amplify_UI_Components_React_1.Input, { placeholder: 'Password', theme: theme, uiFramework: uiFramework, onChange: _this.handleInputChange, type: 'password', name: 'password', key: 'password', label: 'Password' }))),
                            React.createElement(React.Fragment, null,
                                React.createElement(Amplify_UI_Components_React_1.FormField, { theme: theme, uiFramework: uiFramework, key: "confirm_password" },
                                    React.createElement(Amplify_UI_Components_React_1.Input, { placeholder: 'Confirm Password', theme: theme, uiFramework: uiFramework, onChange: _this.handleInputChange, type: 'password', name: "confirm_password", key: "confirm_password", label: 'Confirm Password*' })))),
                        uiFramework === 'material'
                            && React.createElement(core_2.FormHelperText, { style: { position: 'relative', bottom: 20 } }, field.helperText))),
                    _this.checkConditions(field.conditions) && field.key === "acceptTerms" &&
                        React.createElement(Amplify_UI_Components_React_1.FormField, { theme: theme, uiFramework: uiFramework, key: field.key },
                            React.createElement(Amplify_UI_Components_React_1.CheckboxRow, { label: field.acceptText ?
                                    field.acceptText
                                    :
                                        React.createElement("span", null,
                                            core_1.I18n.get("I agree to the"),
                                            ' ',
                                            field.url ?
                                                React.createElement("a", { href: field.url, rel: "noopener noreferrer", target: "_blank" }, core_1.I18n.get(field.label))
                                                :
                                                    React.createElement("a", { href: "/#", onClick: function () { return _this.changeState('terms'); } }, core_1.I18n.get(field.label))), theme: theme, uiFramework: uiFramework, key: field.value, name: field.key, value: field.value, onChange: _this.handleInputChange })),
                    _this.checkConditions(field.conditions) && field.type === "checkbox" && field.key !== "acceptTerms" &&
                        React.createElement(Amplify_UI_Components_React_1.FormField, { theme: theme, uiFramework: uiFramework, key: field.key },
                            React.createElement(Amplify_UI_Components_React_1.CheckboxRow, { label: core_1.I18n.get(field.label), theme: theme, uiFramework: uiFramework, key: field.value, name: field.key, value: field.value, onChange: _this.handleInputChange })),
                    _this.checkConditions(field.conditions) && (field.type === "radio" && field.options) &&
                        React.createElement(Amplify_UI_Components_React_1.FormField, { theme: theme, uiFramework: uiFramework, key: field.key }, field.options && field.options.map(function (opt) { return (React.createElement(Amplify_UI_Components_React_1.RadioRow, { placeholder: core_1.I18n.get(opt.label), theme: theme, uiFramework: uiFramework, key: opt.value, name: field.key, value: opt.value, onChange: _this.handleInputChange })); })),
                    _this.checkConditions(field.conditions) &&
                        field.type === 'select' && (React.createElement(React.Fragment, null,
                        React.createElement(Amplify_UI_Components_React_1.FormField, { theme: theme, uiFramework: uiFramework, key: field.key },
                            field.required ?
                                React.createElement(Amplify_UI_Components_React_1.InputLabel, { theme: theme, uiFramework: uiFramework },
                                    core_1.I18n.get(field.label),
                                    " *") :
                                React.createElement(Amplify_UI_Components_React_1.InputLabel, { theme: theme, uiFramework: uiFramework }, core_1.I18n.get(field.label)),
                            React.createElement(Amplify_UI_Components_React_1.Select, { placeholder: core_1.I18n.get(field.placeholder), theme: theme, uiFramework: uiFramework, type: field.type, name: field.key, key: field.key, helperText: field.helperText, onChange: _this.handleInputChange, "data-test": data_test_attributes_1.auth.signUp.nonPhoneNumberInput, inputProps: field.inputProps, value: _this.inputs[field.key] }, field.options.map(function (option) { return (React.createElement(Amplify_UI_Components_React_1.Option, { key: option.value, value: option.value, label: option.label, uiFramework: uiFramework, theme: theme })); }))))),
                    _this.checkConditions(field.conditions) &&
                        field.type === 'multi' && (React.createElement(React.Fragment, null,
                        React.createElement(Amplify_UI_Components_React_1.FormField, { theme: theme, uiFramework: uiFramework, key: field.key },
                            field.required ?
                                React.createElement(Amplify_UI_Components_React_1.InputLabel, { theme: theme, uiFramework: uiFramework },
                                    core_1.I18n.get(field.label),
                                    " *") :
                                React.createElement(Amplify_UI_Components_React_1.InputLabel, { theme: theme, uiFramework: uiFramework }, core_1.I18n.get(field.label)),
                            React.createElement(Amplify_UI_Components_React_1.MultiSelect, { isMulti: true, name: field.key, options: field.options, className: "basic-multi-select", classNamePrefix: "select", theme: function (theme) { return (__assign(__assign({}, theme), { borderRadius: "0.3rem", transition: '#09D1B4 0.15s ease-in-out, box-shadow 0.15s ease-in-out', colors: __assign(__assign({}, theme.colors), { primary: '#09D1B4' }) })); }, onChange: function (selectedItems) {
                                    var evt = {
                                        target: {
                                            value: selectedItems,
                                            type: field.type,
                                            name: field.key,
                                            id: field.key,
                                        }
                                    };
                                    _this.handleInputChange(evt);
                                } })))),
                    _this.checkConditions(field.conditions) &&
                        field.key !== 'username' &&
                        field.key !== 'phone_number' &&
                        !field.options &&
                        field.type !== 'password' &&
                        field.type !== 'multi' &&
                        field.type !== 'checkbox' &&
                        field.type !== 'radio' &&
                        React.createElement(Amplify_UI_Components_React_1.FormField, { theme: theme, uiFramework: uiFramework, key: field.key },
                            React.createElement(Amplify_UI_Components_React_1.Input, { autoFocus: _this.signUpFields.findIndex(function (f) {
                                    return f.key === field.key;
                                }) === 0 ? true : false, placeholder: core_1.I18n.get(field.placeholder), theme: theme, uiFramework: uiFramework, type: field.type, name: field.key, key: field.key, helperText: field.helperText, onChange: _this.handleInputChange, "data-test": data_test_attributes_1.auth.signUp.nonPhoneNumberInput, inputProps: field.inputProps, label: field.required ? core_1.I18n.get(field.label) + " *" : core_1.I18n.get(field.label) }))));
            })),
            React.createElement(Amplify_UI_Components_React_1.SectionFooter, { theme: theme, uiFramework: uiFramework, "data-test": data_test_attributes_1.auth.signUp.footerSection },
                React.createElement(Amplify_UI_Components_React_1.SectionFooterPrimaryContent, { theme: theme, uiFramework: uiFramework },
                    React.createElement(Amplify_UI_Components_React_1.Button, { onClick: this.signUp, theme: theme, uiFramework: uiFramework, "data-test": data_test_attributes_1.auth.signUp.createAccountButton, block: true, fullWidth: true, variant: "contained", color: "primary", size: "lg" }, core_1.I18n.get('Create Account'))),
                React.createElement(Amplify_UI_Components_React_1.SectionFooterSecondaryContent, { theme: theme, uiFramework: uiFramework },
                    React.createElement(Amplify_UI_Components_React_1.Link, { theme: theme, uiFramework: uiFramework, size: "lg", variant: "outlined", onClick: function () { return _this.changeState('signIn'); }, "data-test": data_test_attributes_1.auth.signUp.signInLink }, core_1.I18n.get('Sign in'))))));
    };
    return SignUp;
}(AuthPiece_1.default));
SignUp.displayName = 'SignUp';
exports.default = SignUp;
//# sourceMappingURL=SignUp.js.map